import { NonSchemaReferenceVariable } from "../../marketing/common/non-schema-variables";
import { baseDataTypeKeys } from "../type-system/data-types/base-types";
import { removeGenericFromType } from "../type-system/data-types/generic-types";
import { Schema, SchemaField } from "../type-system/schema";

/**
 * Filters schema fields based on enabled integrations and visibility rules.
 *
 * @param schema - The schema to extract fields from
 * @param enabledIntegrations - Record of integration names to enabled status
 * @returns Array of SchemaField objects that pass all filters
 */
export function getVisibleDynamicVariables(
  schema: Schema | undefined,
  enabledIntegrations: Record<string, boolean>,
): SchemaField[] {
  const allFields = [
    ...Object.entries(NonSchemaReferenceVariable),
    ...(schema ? Object.entries(schema.fields) : []),
  ];

  const filteredFields = allFields
    // Filter by data type (base types only)
    .filter(([, field]) => {
      const baseType = removeGenericFromType(field.dataType);
      return baseDataTypeKeys.includes(
        baseType as (typeof baseDataTypeKeys)[number],
      );
    })
    .filter(([, field]) => field.shouldInclude?.(enabledIntegrations) ?? true)
    .filter(([, field]) => !field.hideFromInsertionModal)
    .map(([key, field]) => ({ ...field, key }) satisfies SchemaField);

  // Add NonSchemaReferenceVariable fields (always available)
  return filteredFields;
}
